/* eslint-disable ember/no-mixins */
import Controller from '@ember/controller';
import { action } from '@ember/object';
import { alias } from '@ember/object/computed';
import Scopes from '@linc-technologies/linced-common/enums/scopes';
import ReportingBaseMixin from 'linced-app/mixins/reporting-base';

export default class IndexController extends Controller.extend(
  ReportingBaseMixin,
) {
  Scopes = Scopes;

  @alias('groupController.selectedGroup')
  selectedGroup;

  @alias('groupController.templateDraftInfo')
  templateDraftInfo;

  @alias('groupController.isLoadingWriteView')
  isLoadingWriteView;

  @alias('groupController.isLoadingDraftInfo')
  isLoadingDraftInfo;

  @alias('parentController.activeReportTemplates')
  activeReportTemplates;

  @alias('groupController.historicYearsData')
  historicYearsData;

  @alias('groupController.isLoadingHistoric')
  isLoadingHistoric;

  @alias('groupController.loadingReportId')
  loadingReportId;

  @alias('groupController.activeCards')
  activeCards;

  // Pure forwarders to the group controller, which owns the state and the
  // transitions. They must pass every argument through, not just the report:
  // the timeline cards invoke these with (report, period), and dropping that
  // second argument silently sends write/review/view to the template's
  // current period instead of the card's — so a historic card lands on an
  // empty screen for the wrong period.
  @action
  handleWriteOrStartReports(...args) {
    this.groupController.writeOrStartReports(...args);
  }

  @action
  openWriteReports(...args) {
    this.groupController.openWriteReports(...args);
  }

  @action
  openReviewReports(...args) {
    this.groupController.openReviewReports(...args);
  }

  @action
  openViewReports(...args) {
    this.groupController.openViewReports(...args);
  }

  @action
  openWriteComments(...args) {
    this.groupController.openWriteComments(...args);
  }

  @action
  openPublishReports(...args) {
    this.groupController.openPublishReports(...args);
  }

  @action
  selectReport(...args) {
    this.groupController.selectReport(...args);
  }
}
